import { createSelector } from 'reselect';
export const getWebinars = state => state.resources.goToWebinar.webinars;
const getGoToWebinarSettings = state => state.resources.goToWebinar.settings;
export const getIsGoToWebinarEnabled = createSelector([getGoToWebinarSettings], settings => {
  return settings.accessTokenValid && settings.enabled && (!settings.accessTokenExpiration || new Date().getTime() < settings.accessTokenExpiration);
});
const getGoToWebinarEligibleForms = state => state.resources.goToWebinar.eligibleForms;
const getFormGuid = (state, props) => props.formGuid;
export const makeGetIsFormEligible = () => {
  return createSelector([getGoToWebinarEligibleForms, getFormGuid], (eligibleForms, guid) => eligibleForms.has(guid));
};